module.exports = __webpack_public_path__ + "static/media/unlocked-left.be2dcb9c.svg";